import React from 'react';
import { Col } from 'antd';
import { ColProps as ColCopyProps } from 'antd/lib/col';

export type ColProps = ColCopyProps;

const ProCol: React.FC<ColProps> = React.forwardRef<any, ColProps>(
  (props, ref) => {
    const { children, ...resProps } = props;

    return (
      <Col ref={ref} {...resProps}>
        {children}
      </Col>
    );
  },
);

export default ProCol;
